import { useEffect, useState } from "react";

export interface SaveToastState {
	key: string;
	receiptIds: string[];
	message: string;
	detail?: string | undefined;
	changes?: string[];
	newCell?: string | undefined;
}

/**
 * "도감에 넣었어요 · 되돌리기" for six seconds after a save. After that the
 * record can still be removed through the trash (#7).
 */
export function SaveToast({
	toast,
	onUndo,
	onDone,
}: {
	toast: SaveToastState;
	onUndo: (ids: string[]) => Promise<boolean>;
	onDone: () => void;
}) {
	const [state, setState] = useState<"idle" | "busy" | "failed" | "undone">(
		"idle",
	);
	useEffect(() => {
		const timer = window.setTimeout(onDone, state === "undone" ? 2500 : 6000);
		return () => window.clearTimeout(timer);
	}, [onDone, state]);
	return (
		<aside className="save-toast" aria-live="polite">
			<div>
				<strong>
					{state === "undone" ? "저장을 취소했어요" : toast.message}
				</strong>
				{state !== "undone" && toast.changes ? (
					<ol>
						{toast.changes.map((line) => (
							<li key={line}>{line}</li>
						))}
					</ol>
				) : null}
				{state !== "undone" && toast.newCell ? (
					<small>{toast.newCell}</small>
				) : null}
				{state === "failed" ? (
					<small>되돌리지 못했어요. 내역의 삭제를 써 주세요.</small>
				) : toast.detail && !toast.changes && state !== "undone" ? (
					<small>{toast.detail}</small>
				) : null}
			</div>
			{state === "undone" ? null : (
				<button
					type="button"
					disabled={state === "busy"}
					onClick={async () => {
						setState("busy");
						setState((await onUndo(toast.receiptIds)) ? "undone" : "failed");
					}}
				>
					되돌리기
				</button>
			)}
		</aside>
	);
}
